// extracted by mini-css-extract-plugin
module.exports = {"container":"Switch_container__3wekz","button":"Switch_button__doBVC","active":"Switch_active__1EoES"};